import { render, staticRenderFns } from "./newProductFirstBatchLibrary.vue?vue&type=template&id=6cdcfb00&scoped=true&"
import script from "./newProductFirstBatchLibrary.vue?vue&type=script&lang=js&"
export * from "./newProductFirstBatchLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdcfb00",
  null
  
)

export default component.exports